import * as ActionTypes from '../constants/actionTypes';
import { SignUpState } from '../models';

const signUpReducer = (state: SignUpState = {} as any, action: any) => {
  switch(action.type) {
    case ActionTypes.SIGN_UP:
      return {
        ...state,
        info: action.signUp
       };
    case ActionTypes.SIGN_UP_SUCCESS:
      return {
        ...state,
        signUpError: '',
        hasSubmitted: true
       };
    case ActionTypes.SIGN_UP_FAILURE:
      return {
        ...state,
        signUpError: action.errorMessage as string,
        hasSubmitted: true
       };
    default:
      return state;
  }
};

export default signUpReducer;
